import React from "react";
import styled from "styled-components";
import { H4, P, Description } from "./typography";
import { r } from "../utils";
import checkImage from "../../assets/check.png";
import ArrowLink from "./ArrowLink";
import { slugify } from "../utils";

const List = styled.div`
  display: flex;
  flex-direction: column;
  padding: 4rem 0;
`;

const Position = styled.div`
  ${r("padding", "2.5rem 2rem", "2.5rem .5rem 1.5rem")};
  max-width: 42rem;
`;

const CareerText = P.extend`
  font-size: 1.2rem;
  line-height: 1.6;
`;

export default ({ list = [] }) =>
  <List>
    {list.map(position =>
      <Position position={position}>
        <H4 serif>
          {position.title}
        </H4>
        <CareerText>
          {position.description.description}
        </CareerText>
        {position.title !== "No Open Positions" &&
          <CareerText style={{ paddingTop: ".3rem" }}>
            <ArrowLink
              to={`/careers/${position.id}#${slugify(position.title)}`}
            >
              Apply for position
            </ArrowLink>
          </CareerText>}
      </Position>
    )}
  </List>;



// WEBPACK FOOTER //
// ./src/components/PositionList.js